import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AuthCard from '../../components/auth/AuthCard';
import { AuthService } from '../../service/AuthService';
import { LocalStorageService } from '../../service/LocalStorageService';
import { useAuthStore } from '../../store/storeAuth';
import { useNotificationStore } from '../../store/storeNotifications';

const PENDING_CONFIRM_SESSION_KEY = 'pendingConfirmSameBrowser';

export const setPendingConfirmSameBrowser = () => {
  localStorage.setItem(PENDING_CONFIRM_SESSION_KEY, '1');
};

export const clearPendingConfirmSameBrowser = () => {
  localStorage.removeItem(PENDING_CONFIRM_SESSION_KEY);
};

const isSameBrowserAsSignUp = () => {
  return localStorage.getItem(PENDING_CONFIRM_SESSION_KEY) === '1';
};

const ConfirmAccount = () => {
  const { userId } = useParams<{ userId: string }>();
  const navigate = useNavigate();
  const [confirmMessage, setConfirmMessage] = useState('');
  const { setNotification } = useNotificationStore(state => state);
  const { setAuthUser, setAccessToken } = useAuthStore(state => state);

  useEffect(() => {
    const abortController = new AbortController();
    const confirmAccount = async (userId: string) => {
      try {
        const response = await AuthService.confirmAccount(userId!, abortController.signal);
        const data = (response as any)?.data;
        const shouldAutoSignIn = isSameBrowserAsSignUp() && !!data?.accessToken;

        if (shouldAutoSignIn) {
          clearPendingConfirmSameBrowser();
          setAuthUser(data);
          LocalStorageService.setItem('accessToken', data.accessToken);
          setAccessToken(data.accessToken);
          setConfirmMessage('Account confirmed! Signing you in...');
          setNotification({ type: 'success', message: 'Account confirmed. Welcome!' });
          navigate('/', { replace: true });
        } else {
          setConfirmMessage('Account confirmed successfully!');
        }
      } catch (error: any) {
        if (error?.message === 'User not found!') {
          setConfirmMessage('User not found!');
        } else if (error?.message === 'User already confirmed!') {
          setConfirmMessage('User already confirmed!');
        }
        setNotification({ type: 'error', message: 'Something went wrong' });
      }
    };

    if (userId) confirmAccount(userId);
    return () => { abortController.abort(); };
  }, [userId, navigate, setNotification, setAuthUser, setAccessToken]);

  return (
    <AuthCard>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 24, padding: '16px 0', textAlign: 'center' }}>
        <h2 className="auth-form__title">{confirmMessage}</h2>
        <button onClick={() => navigate('/')} className="auth-btn-confirm">
          Return to login
        </button>
      </div>
    </AuthCard>
  );
};

export default ConfirmAccount;
